// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__MZ-1d","addWidgetButton":"Header_addWidgetButton__3dLB9","dashboardTabs":"Header_dashboardTabs__17qc-","active":"Header_active__VfHFp"};